import { useEffect } from 'react';
import { useAuthStore } from '../../store/authStore';
import { userService } from '../../services/user/user.service';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../lib/firebase/init';
import { logger } from '../../utils/logger';

export const useAuth = () => {
  const { setUser, setLoading, setError } = useAuthStore();

  useEffect(() => {
    logger.info('Setting up auth state listener');
    let mounted = true;

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!mounted) return;

      try {
        if (firebaseUser) {
          logger.info('Firebase user authenticated', { uid: firebaseUser.uid });
          const userData = await userService.getUser(firebaseUser.uid);
          
          if (mounted) {
            if (userData) {
              logger.info('User profile loaded', { uid: userData.id, role: userData.role });
              setUser(userData);
            } else {
              logger.warn('No user profile found');
              setUser(null);
            }
          }
        } else {
          if (mounted) {
            logger.info('No firebase user');
            setUser(null);
          }
        }
      } catch (error) {
        logger.error('Auth state change error:', error);
        if (mounted) {
          setError(error instanceof Error ? error.message : 'Authentication error');
          setUser(null);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    });

    return () => {
      mounted = false;
      unsubscribe();
    };
  }, [setUser, setLoading, setError]);

  return useAuthStore(state => ({
    user: state.user,
    loading: state.loading,
    error: state.error
  }));
};